import React, { useState, useEffect } from "react";
import { useForm } from '../../hooks/useForm';
import { useAxiosPost } from '../../hooks/useAxiosPost';
import './ideasForm.css'
import { useTranslation } from "react-i18next";

const IdeasForm = () => {
    const [count, setCount] = useState(0);
    const [correo, setCorreo] = useState('');
    const [nombre, setNombre] = useState('');
    const [isValidEmail, setIsValidEmail] = useState(true);

    const onInputChangeCorreo = (e) => {
        const { value } = event.target;
        setCorreo(value);
    
        // Validar el formato del correo electrónico
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        setIsValidEmail(emailRegex.test(value));
      };
      

    const onInputChangeNombre = (e) => {
        setNombre(e.target.value);
    };

    const [t, i18n] = useTranslation("ideas_libertad");
    const [t2] = useTranslation("detail_blog");

    const [formSubmitted, setFormSubmitted] = useState(false)
    const { formState, onInputChange, subject, body, onResetForm } = useForm({
        subject: '',
        body: '',
        correo: correo
    });

    const notAllowedChars = ['"', '`', '=', ';', '[', ']', '{', '}', '(', ')', '/', '\\', '&', '<', '>'];

    const handleInputChangeValidated = (event) => {
        onInputChange(event);
        const value = event.target.value;
        //setCorreo(e.target.value);

        // Verificar si el valor contiene algún carácter no permitido
        const containsNotAllowedChars = notAllowedChars.some(char => value.includes(char));
        let cleanBody = '';

        if (containsNotAllowedChars) {
            event.target.classList.add("invalid");
            for (let character of body) {
                cleanBody += notAllowedChars.includes(character) ? '' : character;
            }
            onInputChange({ target: { name: 'body', value: cleanBody } });
        } else {
            event.target.classList.remove("invalid");
        }

        setCount(event.target.value.length);
    }

    const handleFormSubmitted = (value) => {
        setFormSubmitted(value);
    };

    const { data, isLoading, error } = useAxiosPost(
        formSubmitted ? 'https://www.ricardosalinas.com/S8JFmpfeLW5iUVROXz2owTPU/api/email/send-email-comment' : null,
        { fromName: ' ', from: ' ', to: ' ', subject: 'Nueva propuesta tema', body: nombre + '\n' +correo + '\n' + subject + '\n' + body, isBodyHtml: false }, //correo + '<br/>' +
        handleFormSubmitted);

    const onFormSubmit = (event) => {
        event.preventDefault();

        //if (subject.length <= 1 || body.length <= 1 || nombre.length <= 1) return;

        if(nombre.length <= 1)
        {
            alert((t2('comments.v_nombre')));
            return;
        }
            
        if(correo.length <= 1)
        {
            alert((t2('comments.v_email')));
            return;
        }
        
        if(body.length <= 1)
        {
            alert((t2('comments.v_idea')));
            return;
        }

        if (isValidEmail) {
            console.log('Correo electrónico válido:', correo);
          } else {
            alert((t2('comments.v_valido')));
            return;
          }

        let cleanBody = '';

        for (let character of body) {
            cleanBody += notAllowedChars.includes(character) ? ' ' : character;
        }

        onInputChange({ target: { name: 'body', value: cleanBody } });

        setFormSubmitted(true);


    }


    useEffect(() => {

        if (data === undefined) {
            onResetForm();
        }
    }, [data]);


    return (
        <div class="comenta_ideas">
            <form onSubmit={onFormSubmit}>
                <div className="row4_LB">
                    <p className="preg1_LB">
                        {(t('form.pregunta'))}
                    </p>
                </div>

                <div className="row4_LB">
                    <div className="preg">
                        <input
                            type="text"
                            className="dropb escritorio input"
                            name="nombre"
                            onChange={onInputChangeNombre}
                            value={nombre}
                            placeholder={(t('form.nombre'))}
                        />
                        <input
                            type="text"
                            className="dropb movil input"
                            name="nombre"
                            onChange={onInputChangeNombre}
                            value={nombre}
                            placeholder={(t('form.nombre'))}
                        />
                    </div>
                    <div className="preg">
                        <input
                            type="email"
                            className="dropb escritorio input"
                            name="correo"
                            onChange={onInputChangeCorreo}
                            value={correo}
                            placeholder={(t('form.email'))}
                        />
                        <input
                            type="email"
                            className="dropb movil input"
                            name="correo"
                            onChange={onInputChangeCorreo}
                            value={correo}
                            placeholder={(t('form.email'))}
                        />
                    </div>
                    <div className="preg">
                        <select className="dropb escritorio" name="subject" onChange={onInputChange} value={subject}>
                            default <option value="" selected >
                                &nbsp;&nbsp;&nbsp;&nbsp;{(t('form.selecciona-categoria'))}{" "}
                            </option>
                            <option value="Categoria de interes:Libertad">&nbsp;&nbsp;&nbsp;&nbsp;{(t('categorias.categoria-1'))}</option>
                            <option value="Categoria de interes:Educación">&nbsp;&nbsp;&nbsp;&nbsp;{(t('categorias.categoria-2'))}</option>
                            <option value="Categoria de interes:Arte & Cultura">
                                &nbsp;&nbsp;&nbsp;&nbsp;{(t('categorias.categoria-3'))}
                            </option>
                            <option value="Categoria de interes:Medio Ambiente">
                                &nbsp;&nbsp;&nbsp;&nbsp;{(t('categorias.categoria-4'))}
                            </option>
                            <option value="Categoria de interes:Liderazgo">&nbsp;&nbsp;&nbsp;&nbsp;{(t('categorias.categoria-5'))}</option>
                            <option value="Categoria de interes:Innovación & Emprendiento">
                                &nbsp;&nbsp;&nbsp;&nbsp;{(t('categorias.categoria-6'))}
                            </option>
                            <option value="Categoria de interes:Estado de Derecho">
                                &nbsp;&nbsp;&nbsp;&nbsp;{(t('categorias.categoria-7'))}
                            </option>
                            <option value="Categoria de interes:Biblioteca">&nbsp;&nbsp;&nbsp;&nbsp;{(t('categorias.categoria-8'))}</option>
                            <option value="Categoria de interes:Prosperidad Incluyente">
                                &nbsp;&nbsp;&nbsp;&nbsp;{(t('categorias.categoria-9'))}
                            </option>
                        </select>
                        <select className="dropb movil" name="subject" onChange={onInputChange} value={subject}>
                            default<option value="" selected disabled hidden>
                                &nbsp;&nbsp;&nbsp;&nbsp;{(t('form.selecciona-categoria'))}{" "}
                            </option>
                            <option value="Categoria de interes:Libertad">&nbsp;&nbsp;&nbsp;&nbsp;{(t('categorias.categoria-1'))}</option>
                            <option value="Categoria de interes:Educación">&nbsp;&nbsp;&nbsp;&nbsp;{(t('categorias.categoria-2'))}</option>
                            <option value="Categoria de interes:Arte & Cultura">
                                &nbsp;&nbsp;&nbsp;&nbsp;{(t('categorias.categoria-3'))}                                </option>
                            <option value="Categoria de interes:Medio Ambiente">
                                &nbsp;&nbsp;&nbsp;&nbsp;{(t('categorias.categoria-4'))}
                            </option>
                            <option value="Categoria de interes:Liderazgo">&nbsp;&nbsp;&nbsp;&nbsp;{(t('categorias.categoria-5'))}</option>
                            <option value="Categoria de interes:Innovación & Emprendiento">
                                &nbsp;&nbsp;&nbsp;&nbsp;{(t('categorias.categoria-6'))}
                            </option>
                            <option value="Categoria de interes:Estado de Derecho">
                                &nbsp;&nbsp;&nbsp;&nbsp;{(t('categorias.categoria-7'))}
                            </option>
                            <option value="Categoria de interes:Biblioteca">&nbsp;&nbsp;&nbsp;&nbsp;{(t('categorias.categoria-8'))}</option>
                            <option value="Categoria de interes:Prosperidad Incluyente">
                                &nbsp;&nbsp;&nbsp;&nbsp;{(t('categorias.categoria-9'))}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="contenedor_LisBlog1 ">
                    <div class="row4_LB">
                        <div class="row4_LB">
                            <div class="preg2">
                                <textarea
                                    type="text"
                                    class="form"
                                    name="body"
                                    id="numLetras"
                                    maxLength={560}
                                    placeholder={(t('form.comparte-PH'))}
                                    value={body}
                                    onChange={handleInputChangeValidated}
                                />
                            </div>
                        </div>
                    </div>

                    <div>
                        <p class="conteo">{count}/560 {(t('form.caracteres'))}</p>
                    </div>


                    <div class="row4_LB">
                        <div class="div_bot3_LB">
                            {
                                isLoading ?
                                    (<span>Enviando...</span>) :
                                    (<button class="buton3_LB" type='submit'>{(t('form.enviar'))}</button>)
                            }
                        </div>
                    </div>



                </div>
            </form>
        </div>
    );
};

export default IdeasForm;
